export const BASE_URL = process.env.REACT_APP_API_URL;

export const ME = 'ME';

export const HORSES_LIST = 'HORSES_LIST';
export const HORSES_PUT = 'HORSES_PUT';

export const UPDATES_LIST = 'UPDATES_LIST';
export const POST_HORSE_UPDATE_ON_SALE = 'POST_HORSE_UPDATE_ON_SALE';
export const DELETE_HORSE_UPDATE_ON_SALE = 'DELETE_HORSE_UPDATE_ON_SALE';

export const HORSE_PHOTO_UPLOAD = 'HORSE_PHOTO_UPLOAD';
export const HORSE_PHOTOS_DELETE_SINGLE = 'HORSE_PHOTOS_DELETE_SINGLE';
export const ENHANCED_HORSE_PHOTOS_DELETE_ALL = 'ENHANCED_HORSE_PHOTOS_DELETE_ALL';

export const SALES_GET = 'SALES_GET';
export const SALES_FIND = 'SALES_FIND';
export const SALES_PUT = 'SALES_PUT';
export const SALES_PDF_UPLOAD = 'SALES_PDF_UPLOAD';
export const SALES_STATS_GET = 'SALES_STATS_GET';

export const SET_SORT = 'SET_SORT';

export const TRIGGER_UNDER_TACK_SHOW_YOUTUBE = 'TRIGGER_UNDER_TACK_SHOW_YOUTUBE';
export const CHECK_FOR_PP_ON_HORSES = 'CHECK_FOR_PP_ON_HORSES';
export const CHECK_FOR_ENHANCED_FILES_ON_HORSES = 'CHECK_FOR_ENHANCED_FILES_ON_HORSES';
